/// <reference path="../../app.definition.ts" />

export class APIs {
    public static docApis = {
        "DOCUMENT": {
            "CREATE_RS": '/createDocumentMetadata',
            "COPY_RS_DOCUMENT": '/document/copy',
            "UPDATE_TITLE": '/documents/${documentId}',
            "SHARE_RS_DOCUMENT": '/resourceLibrary/documents/${documentId}/share',
            "DELETE_DOCUMENT": {
                url: '/documents/${id}/delete',
                method: 'get'
            },
            "GET_SHARABLE_LINK": {
                url: '/documents/${documentId}/shareableLink',
                method: 'post'
            },
            "GET_SHARED_DOCUMENT": '/public/${code}',
            "SHARE_DOCUMENT": '/documents/${documentId}/shares',
            "MOVE_DOCUMENT": '/document/${id}/documentFolder/${parentId}'
        },
        "LINK": {
            "CREATE_RS": '/urlLink',
            "COPY_RS_DOCUMENT": '/urlLink/copy',
            "UPDATE_TITLE": '/urlLink/${linkId}',
            "SHARE_RS_DOCUMENT": '/urlLink/RL/share',
            "DELETE_DOCUMENT": {
                url: '/urlLink/${id}',
                method: 'delete'
            },
            "GET_SHARABLE_LINK": {
                url: '/urlLink/${linkId}/shareableLink',
                method: 'get'
            },
            "GET_SHARED_DOCUMENT": '/public/vlink/${code}',
            "SHARE_DOCUMENT": '/urlLink/share',
            "MOVE_DOCUMENT": "/urlLink/${id}/linkFolder/${parentId}"

        },
        "DISCUSSION": {
            "UPDATE_TITLE": '/documents/${documentId}',
            "DELETE_DOCUMENT": {
                url: '/documents/${id}/delete',
                method: 'get'
            },
            "SHARE_DOCUMENT": '/documents/${documentId}/shares',
            "MOVE_DOCUMENT": '/document/${id}/documentFolder/${parentId}'


        }
    };
    public static GET_IDENTITY = '/identity';
    public static LOG_ERROR = '/exception-message';
    public static GET_USER_SUBSCRIPTION = '/getUserSubscription';
    public static UPDATE_TEAM_ROLE = '/teamRoles/${teamRoleId}';
    public static ADD_TEAM_ROLE = '/teamRoles';
    public static ADD_USER_BY_EMAIL = '/users/teamMembers';
    public static LOGOUT = '/identity/logout';
    public static LOG_DETAILS_TO_BACKEND = '/documentstats';
    public static GET_COUNTRIES = '/countries';
    public static CREATE_COMMENT = '/documents/${documentId}/comments';
    public static UPDATE_COMMENT = '/documents/${documentId}/comments/${commentId}';
    public static DELETE_COMMENT = '/documents/${documentId}/comments/${commentId}';
    public static GET_COMMENTS = '/documents/${documentId}/comments/retrieve';
    public static GET_INVITATION_INFO = '/invitations';
    public static GET_TMS_FOR_TEAM = '/subjects/getMemberInfo';
    public static GET_PENDING_INVITATION = '/getPendingInvitations';
    public static GET_TEAM_MEMBERS = '/subjects/${subjectId}/teamMembers';
    public static GET_SUBJECTS_TMS = '/subjects/teamMembers';
    public static UPDATE_TEAM_MEMBER = '/users/teamMembers';
    public static CREATE_INACTIVE_TM = '/users/teamMembers';
    public static SIGNUP = '/signup';
    public static UPDATE_USER = '/users/${userId}';
    public static CHANGE_PASSWORD = '/identity/key-password';
    public static GET_PERMISSIONS_FOR_USER_V2 = '/users/permissionsList';
    public static GET_PERMISSIONS_FOR_SUBJECTS = '/v3/subjects/permissionsList';
    public static GET_PERMISSIONS_FOR_USER = '/users/permissions/subjects';
    public static GET_CUSTOM_ATTR_TEMPLATE = '/attribute/org/template';
    public static GET_SECTION_TEMPLATE = '/attribute/${subjectId}/section/template'
    public static GET_SUBJECT_V2 = '/v2/subjects/${subjectId}';
    public static GET_SUBJECTS_V2 = '/v2/subjects/list';
    public static POST_DOCUMENT_LIST_V2 = '/v2/document/list';
    public static GET_SUBJECTS_V3 = '/v3/subjects/list';
    public static CREATE_SUBJECT = '/subjects';
    public static CREATE_SUBJECT_MULTI = '/subjects/multiple';
    public static CREATE_SUBJECT_BEHALF = '/subjects/onBehalf';
    public static UPDATE_SUBJECT = '/subjects/${subjectId}';
    public static UPDATE_SUBJECT_V2 = '/subjects/customAttributes/${subjectId}';
    public static UPDATE_MULTIPLE_SUBJECT = '/subjects/updateMultiple';
    public static DELETE_SUBJECT = '/subject/${subjectId}';
    public static REMOVE_ORG_FROM_TEAM = '/subjects/${subjectId}/organization/${orgId}';

    public static SAVE_SIGNATURE = '/users/${userId}/signature';
    public static GET_SIGNATURE_TEMPLATE = '/documents/signatureTemplate';
    public static CREATE_DOCUMENT = '/subjects/${subjectId}/documents';
    public static CREATE_FOLDER = '/users/${userId}/folders';
    public static UPDATE_FOLDER = '/users/${userId}/folders/${id}';
    public static COPY_DOCUMENT = '/document/copy';
    public static CREATE_DOCUMENT_SIGNATURE = '/documents/${documentId}/signature';
    public static UPDATE_PDF_WITH_SIGNATURE = '/documents/${documentId}/users/${userId}/signature';
    public static STAGE_DOCUMENT_SIGNATURE = '/documents/${documentId}/signature/${groupId}/user/${userId}';
    public static GET_DISCUSSION = '/documents/${documentId}';
    public static GET_DOCUMENTS_OR_DISCUSSIONS = '/users/${userId}/documents';
    public static GET_DOCUMENT_IDS = '/users/${userId}/fetchDocIds';
    public static CHECK_PASSWORD = '/identity/key-password';
    public static CHECK_INVITATION_TOKEN = '/check-token';
    public static PROCESS_INVITATION = '/invitations';
    public static VAULT_KEY_RESET_REQ = '/users/vaultKey';
    public static UPDATE_POLICY = '/users/${userId}/policy';
    public static GET_DOCUMENT_USERS = '/documents/${documentId}/users';
    public static SEND_INVITATION_TO_PROVIDER = '/invitations/provider';
    public static SUGGEST_PROVIDER = '/suggestProvider';
    public static GET_SUGGESSIONS = '/suggestions';
    public static PROCESS_SUGGESTION = '/processSuggestion';
    public static SEND_INVITATION = '/invitations/parent';
    public static GET_TEAMROLES = '/teamRoles';
    public static GET_DOCUMENT_TYPES = '/documentTypes';
    public static GET_PROJECT_TYPES = '/project/types';
    public static VALIDATE_PRE_SIGNUP = '/validations/preSignup';
    public static TRANSFER_OWNERSHIP = '/subjects/${subjectId}/owners/changeOwnership';
    public static GET_TRANSFER_OWNERSHIP_REQUEST = '/ownershipTransferRecords';
    public static PROCESS_TRANSFER_OWNERSHIP = '/subjects/${subjectId}/owners/processOwnershipTransfer';
    public static UPDATE_OWNERSHIP_RECORD = '/subjects/${subjectId}/owners/updateOwnershipTransferRecord';
    public static EXIT_TEAM = '/subjects/${subjectId}/providers'
    public static UPDATE_USER_NOTIFICATION_FLAG = '/userNotifications';
    public static INIT_BACKUP_PWD_RESET = '/passwordreset';
    public static BACKUP_PASSWORD_RESET = '/passwordreset';
    public static REQUEST_NEW_INVITE = '/requestNewInvite';
    public static DELETE_INVITED_TM = '/providers/${providerId}/delete';
    public static GET_USER_TYPES = '/user/types';
    public static GET_USERS_BY_ID = '/user/list';
    public static GET_SUBJECTS_BY_ID_1 = '/subjectList';
    public static SEARCH = '/search';
    public static GET_CARE_DETAILS = '/careDetails';
    public static GET_CR_PROFILE = '/getCRProfile/${subjectId}';
    public static UPDATE_CR_PROFILE = '/getCRProfile/${subjectId}';
    public static GET_SUBJECT_IMAGES = '/careRecipient/${subjectId}/photo';
    public static ADD_SUBJECT_IMAGES = '/careRecipient/${subjectId}/photo';
    public static UPDATE_SUBJECT_IMAGES = '/careRecipient/${subjectId}/photo';
    public static DOWNLOAD_SHARED_DOCUMENT = '/public/download/${code}';
    public static UPDATE_NOTIFICATION_FLAGS = '/v2/users/updatenotifications';
    public static MARK_NOTIFICATION_AS_VIEWED = '/users/${userId}/document/views';
    public static FETCH_NOTIFICATIONS = '/v2/users/notifications'; //old endpoint '/users/${userId}/notifications'
    public static TEAM_CO_CAPTAIN_ACTION = '/subjects/${subjectId}/providers/${providerId}';
    public static GET_LEA_CAMPUS = '/schoolDistrict/${orgId}/attributes';
    public static GET_SCHOOLS_FOR_REPORT = '/schoolDistrict/${orgId}/schools';
    public static GET_GRADES = '/teams/school/grades';
    public static GET_PROVIDERS_FOR_REPORT = '/teams/providers/${orgId}';
    public static GET_SUBJECTS_OF_ORG = '/orgs/${orgId}/subjects';
    public static GET_CATEGORIES = '/metadataOption';
    public static GET_STUDENT_GRADES = '/teams/school/${schoolId}/grades';
    public static GET_USER_STATS = '/users/getStats';
    public static CREATE_DOCUMENT_METADATA = '/subjects/${subjectId}/createDocumentMetadata';
    public static GET_VK_RESET_INFO = '/public/passwordreset/getinfo';
    public static GET_PWD_POLICIES = '/getPasswordPolicies';
    public static GET_DOCUMENT_LINK = '/documentslink/${documentId}';
    public static SEARCH_TEAM_MEMBER = '/users/filterUsers';
    public static GET_PLAN = '/plans';
    public static GET_ENTERPRISE_FEATURES = '/users/enterpriseFeatures';
    public static GET_AUTO_SHARE_CHECK_LIST = '/getAutoshareChecklist/${subjectId}';
    public static GET_AVAILABLE_FORMS = '/v2/forms/available';
    public static GET_AVAILABLE_SERVICE = '/availableService';
    public static GET_SERVICE_UNIT_TYPES = '/service/unit/types';
    public static GET_SERVICE_OPTION = '/service/option';
    public static GET_SERVICE_OPTION_ORG = '/service/option/${orgId}';
    public static GET_SERVICE_TYPES = '/service/type';
    public static GET_ENTERPRISE_PROVIDER_TYPE = '/provider/type';
    public static CREATE_SERVICE = '/service';
    public static GET_SERVICE_NOTES = '/assignedservice/${id}/serviceNotes';
    public static GET_SERVICE_NOTE_FORM_BY_ID = '/assignedservice/${id}/serviceNotes/${noteId}';
    public static VALIDATE_FORM = '/form/validate';
    public static GET_SERVICE_NOTE_TYPES = '/assignedservice/${id}/note/type';
    public static GET_REPORT_LIST = '/forms/reports';
    public static GET_REPORT_CONFIG = '/forms/reportConfig/${reportId}';
    public static GET_HISTORY_CONFIG = '/forms/reportConfig/section/${sectionName}';
    public static GET_CUSTOM_ATTR_FOR_REPORT = '/subject/attributes/get';
    public static GET_DYNAMIC_ATTR = '/form/dynamicAttribute';
    public static GET_DATA = '/data/${collection}';
    public static GET_DYNAMIC_ATTR_FOR_SUBJECT = '/forms/getCollection/${collectionName}/${id}';
    public static GET_REPORT_DATA = '/analytics/getReportData';
    public static GET_PAGINATED_REPORT_DATA = '/report/${reportName}/${sectionName}';
    public static GET_HISTORY_DATA = '/attribute/section/history';
    public static UPDATE_TRIAL_COUNT = '/form/fieldConfigurationTrails';
    public static GET_FORM_FIELD_METADATA = '/metadataOption';
    public static CREATE_SERVICE_NOTE_FORM = '/assignedservice/${id}/notes';
    public static UPDATE_SERVICE_NOTE_FORM = '/assignedservice/${id}/notes';
    public static GET_ASSIGNED_FORMS = '/v2/forms/assigned';
    public static ASSIGN_FORM = '/forms/assigned';
    public static ADD_USERS_TO_FORM = '/forms/assigned/users';
    public static GET_FORM_TEMPLATE = '/forms/${formId}';
    public static GET_ASSIGNED_FORM = '/forms/assigned/${assignmentId}';
    public static GET_FORM_PROVIDERS = '/forms/assigned/${assignmentId}/fields';
    public static SAVE_FORM = '/forms/assigned/${assignmentId}/respond';
    public static SAVE_EMBEDDED_FORM = '/externalForm';
    public static SAVE_FORM_ASSIGNED_REMINDER = '/forms/assigned/${assignmentId}/reminder';
    public static SUBMIT_FORM = '/forms/assigned/${assignmentId}/submit';
    public static DELETE_FORM_ASSIGNMENT = '/forms/assigned/${assignmentId}/delete';
    public static SIGN_THE_FORM = '/form/assigned/sign';
    public static TRIGGER_FORM_WORKFLOW = '/forms/assigned/${assignmentId}/triggerFormWorkflow';
    public static SAVE_DYNAMIC_ATTR_OF_FORM = '/form/dynamicAttribute';
    public static UPDATE_DYNAMIC_ATTR_OF_FORM = '/form/dynamicAttribute/${id}';
    public static GET_ASSIGNED_SERVICE = '/assignedservices';
    public static GET_CLOSED_SERVICES = '/closedservices';
    public static GET_PROVIDERS = '/user/${id}/providers';
    public static ASSIGN_SERVICE = '/service/${serviceId}/assign';
    public static SHARE_SERVICE = '/assignedservice/${id}/share';
    public static CLOSE_SERVICE = '/assignedservice/${id}/status';
    public static UPDATE_ASSIGNED_SERVICE = '/assignedservice/${id}';
    public static GET_ASSIGNED_SERVICE_FORM_ID = '/assignedservice/${id}';
    public static SHARE_SERVICE_NOTE = '/assignedservice/${id}/note/${noteId}/share';
    public static ASSOCIATE_TEAM_PROJECT = '/project/${projectId}/subjects';
    public static RELOAD_TEAM_MEMBER = '/subjects/${subjectId}/teamMembers/${userId}';
    public static GET_COVERSHEET = '/upload/batch';
    public static GET_COVERSHEET_UPLOADS = '/upload/batch/${batch}';
    public static SHARE_COVERSHEET_LINK = '/upload/batch/${batch}/share';
    public static FETCH_FOLDERS = '/users/${userId}/folders/${id}';
    public static DELETE_DOCUMENT_FOLDER = '/users/${userId}/folders/${id}';
    public static CHECK_EMAIL_EXISTS = '/users/email/check';
    public static GET_WS_URL = '/pubsub/url';
    public static GET_SAS_TOKEN = '/storage/accessToken';
    public static GET_ACTIVE_ORG_USERS = '/org/activeUsers';
    public static CREATE_CLIENT_ACCOUNT = '/create/msuser/${subjectId}';
    public static RESET_CLIENT_PASSWORD = '/reset/msuser/${subjectId}';
    public static GET_STATES = '/states';
    public static GET_FORM_TEMPLATE_BY_TYPE = '/attribute/${orgId}/template/${templateType}';
    public static CHECK_AND_SHARE = '/form/checkAndShare';
    public static GET_USERS = '/${orgId}/users/list';
    public static CREATE_ORG_USER = '/user/create';
    public static UPDATE_ORG_USER = '/user/update';
    public static DOWNLOAD_REPORT_CSV = '/export/report/csv'
    public static CHECK_USER_MEMBERSHIP = '/subject/count/${userId}';
    public static CHECK_USER = '/subject/owner/count/${userId}';
    public static DEACTIVATE_USER = '/users/deactivate/${userId}';
    public static GET_ATTRIBUTE_DATA = '/attribute/entitySchema/${orgId}/attribute/${attributeName}';
    public static BULK_ADD_TO_TEAMS = '/teamMember/${userId}/bulkAdd';
    public static GET_RL_FOLDERS = '/RL/folders';
    public static BULK_REMOVE_FROM_TEAMS = '/teamMember/${userId}/bulkRemove';
    public static LINK_EVENT_REPORT = '/urlLink/event/Report';
    public static CHECK_LINK_MONETIZED = '/getVideoStatus';
    public static GET_YT_DETAILS = '/urlLink/yt/details/${videoId}';
    public static GET_RL_FOLDERS_FILTER = '/RL/folders/${folderOrgId}/filter';
    public static GET_USER_EXPERIENCE = '/users/experience';
    public static GET_USER_INTEGRATIONS = '/user/integrations';
    public static SAVE_ZOOM_INTEGRATION = '/user/integrations/zoom';
    public static SAVE_CALENDAR_INTEGRATION = '/user/integrations/calendar';
    public static SAVE_NOTIFICATION_SETTINGS: string = '/notifications/user/manage';
    public static GET_CARE_ITEMS = '/careItems/list';
    public static CARE_ITEM_INTERACTIONS = '/careItems/userInteractions';
    public static GET_AI_SUMMARY = '/document-summary/getsummary';
    public static REGENERATE_AI_SUMMARY = '/document-summary/regenerate';
    public static CONFIRM_REGENERATE_AI_SUMMARY = '/document-summary/confirm-regenerate';
    public static GET_INVITATION_COUNTS = '/invitation/count';
    public static SEND_BULK_INVITATION = '/invitation/send/all/${invitationType}';
    public static REQUEST_INVITATIONS_IN_BULK = '/invitation/request/all';
    public static ACCEPT_BULK_INVITATIONS = '/invitation/accept/all';
    public static PROCESS_BOT_REQUEST = '/chat/message';
    public static ASSIGN_CREATE_PROJECT_TEAM_FORM = '/users/team-create-form/assign';
    public static GET_SYSTEM_MESSAGES = '/system/messages';
    public static CREATE_SYSTEM_MESSAGE = '/system/messages';
    public static DEACTIVATE_SYSTEM_MESSAGE = '/system/messages/deactivate';
    public static DISMISS_SYSTEM_MESSAGE = '/system/messages/dismiss';
    public static GET_NOTIFICATION_PRERENCES = '/v2/notifications/preferences/metadata';
    public static UPDATE_NOTIFICATION_PREFERENCES = '/v2/users/notification-preferences';
    public static GET_DOCUMENT_SIGNATURE_STATUS = '/v2/document/${documentId}/signature-status';
}

